/* eslint-disable import/no-cycle */
import { Mutation, Query } from '@apollo/client/react/components';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import BookmarkIconFilled from '@mui/icons-material/Bookmark';
import BookmarkIconBorder from '@mui/icons-material/BookmarkBorder';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  ADD_BOOKMARK,
  DELETE_BOOKMARK,
  IS_BOOKMARKED,
} from '../../helpers/graphql/bookmarks';
import { getUser } from '../../helpers/token';
import LoginButton from '../Header/LoginButton';
import RoundNavIconBtn from '../Header/RoundNavIconBtn';

const BookmarkIcon = props => {
  const { isHeader, isButton, isMenuItem } = props;
  const [open, setOpen] = useState(false);

  const isBm = (
    <IsBookmarked
      isHeader={isHeader}
      isButton={isButton}
      isMenuItem={isMenuItem}
      author={props.author}
      permlink={props.permlink}
      onBmChange={props.onBmChange}
      setOpen={() => setOpen(true)}
    />
  );

  const isNotBm = (
    <IsNotBookmarked
      isHeader={isHeader}
      isButton={isButton}
      isMenuItem={isMenuItem}
      author={props.author}
      permlink={props.permlink}
      onBmChange={props.onBmChange}
      setOpen={() => setOpen(true)}
    />
  );

  return (
    <>
      {open && (
        <LoginButton
          open={open}
          hideButtons
          onClickClose={() => setOpen(false)}
          text=" and bookmark your favorite posts"
        />
      )}
      {getUser() ? (
        <Query
          fetchPolicy="network-only"
          query={IS_BOOKMARKED}
          variables={{
            author: props.author,
            permlink: props.permlink,
          }}
        >
          {({ data }) => {
            if (data && data.isBookmarked) {
              return isBm;
            }
            return isNotBm;
          }}
        </Query>
      ) : (
        isNotBm
      )}
    </>
  );
};

const IsBookmarked = props => {
  const { isHeader, isButton, isMenuItem } = props;
  return (
    <Mutation
      mutation={DELETE_BOOKMARK}
      variables={{
        author: props.author,
        permlink: props.permlink,
      }}
    >
      {(deleteBookmark, data) => {
        if (data.data && data.data.deleteBookmark.success) {
          if (props.onBmChange !== undefined) {
            props.onBmChange();
          }
          return (
            <IsNotBookmarked
              isHeader={isHeader}
              isButton={isButton}
              isMenuItem={isMenuItem}
              author={props.author}
              permlink={props.permlink}
              onBmChange={props.onBmChange}
            />
          );
        }
        if (props.isHeader)
          return (
            <RoundNavIconBtn
              color="inherit"
              onClick={getUser() ? deleteBookmark : props.setOpen}
              edge="end"
              aria-label="Bookmark"
            >
              <BookmarkIconFilled />
            </RoundNavIconBtn>
          );
        if (props.isButton)
          return (
            <Button
              fullWidth
              size="small"
              color="inherit"
              onClick={getUser() ? deleteBookmark : props.setOpen}
            >
              <BookmarkIconFilled />
              <Typography noWrap variant="inherit" className="p-1">
                Unsave
              </Typography>
            </Button>
          );
        if (props.isMenuItem)
          return (
            <>
              <MenuItem onClick={getUser() ? deleteBookmark : props.setOpen}>
                <ListItemIcon>
                  <BookmarkIconFilled fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Unsave" />
              </MenuItem>
            </>
          );
        return (
          <RoundNavIconBtn
            onClick={getUser() ? deleteBookmark : props.setOpen}
            aria-label="Bookmark"
          >
            <BookmarkIconFilled />
          </RoundNavIconBtn>
        );
      }}
    </Mutation>
  );
};

const IsNotBookmarked = props => {
  const { isHeader, isButton, isMenuItem } = props;
  return (
    <Mutation
      mutation={ADD_BOOKMARK}
      variables={{
        author: props.author,
        permlink: props.permlink,
      }}
    >
      {(addBookmark, data) => {
        if (data.data && data.data.addBookmark.success) {
          if (props.onBmChange !== undefined) {
            props.onBmChange();
          }
          return (
            <IsBookmarked
              isHeader={isHeader}
              isButton={isButton}
              isMenuItem={isMenuItem}
              author={props.author}
              permlink={props.permlink}
              onBmChange={props.onBmChange}
            />
          );
        }
        if (props.isHeader)
          return (
            <RoundNavIconBtn
              color="inherit"
              onClick={getUser() ? addBookmark : props.setOpen}
              edge="end"
              aria-label="Bookmark"
            >
              <BookmarkIconBorder />
            </RoundNavIconBtn>
          );
        if (props.isButton)
          return (
            <Button
              fullWidth
              size="small"
              color="inherit"
              onClick={getUser() ? addBookmark : props.setOpen}
            >
              <BookmarkIconBorder />
              <Typography noWrap variant="inherit" className="p-1">
                Save
              </Typography>
            </Button>
          );
        if (props.isMenuItem)
          return (
            <>
              <MenuItem onClick={getUser() ? addBookmark : props.setOpen}>
                <ListItemIcon>
                  <BookmarkIconBorder fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Save" />
              </MenuItem>
            </>
          );
        return (
          <RoundNavIconBtn
            onClick={getUser() ? addBookmark : props.setOpen}
            aria-label="Bookmark"
          >
            <BookmarkIconBorder />
          </RoundNavIconBtn>
        );
      }}
    </Mutation>
  );
};

BookmarkIcon.defaultProps = {
  onBmChange: undefined,
};

BookmarkIcon.propTypes = {
  author: PropTypes.string.isRequired,
  permlink: PropTypes.string.isRequired,
  onBmChange: PropTypes.func,
};

IsNotBookmarked.defaultProps = {
  onBmChange: undefined,
};

IsNotBookmarked.propTypes = {
  author: PropTypes.string.isRequired,
  permlink: PropTypes.string.isRequired,
  onBmChange: PropTypes.func,
};

IsBookmarked.defaultProps = {
  onBmChange: undefined,
};

IsBookmarked.propTypes = {
  author: PropTypes.string.isRequired,
  permlink: PropTypes.string.isRequired,
  onBmChange: PropTypes.func,
};

export default BookmarkIcon;
